import { accounts } from "./model/modelAccounts.js";
import { productRowsDefault } from "./model/modelProducts.js";
import { fertiProductRowsDefault } from "./model/modelFertiProducts.js";
import { cropRowsDefault } from "./model/modelCrops.js";
import { companyRowsDefault, sectors } from "./model/modelCompany.js";

import { initMenu, clear } from "./helper.js";
import { hideMenu } from "./shared.js";
import { companyService } from "./services/companies.ts";
import { sectorService } from "./services/sectors.ts";
import { planService } from "./services/plans.ts";
import {
  controlNewPlanProject,
  renderEmptyDataAlertWindow,
} from "./controllerPlan.js";

import { controlOpenPlanProject } from "./controllerOpenPlan.js";

import { plans } from "./model/modelPlan.js";

import { auth } from "./auth.js";
import { auth as authService } from "./services/auth.ts";

import { cropController } from "./controllers/crop_controller.js";
import { companyController } from "./controllers/company_controller.js";
import { sectorController } from "./controllers/sector_controller.js";
import { productController } from "./controllers/product_controller.js";
import { fertiProductController } from "./controllers/ferti_product_controller.js";
import { planController } from "./controllers/plan_controller.js";
import { cropService } from "./services/crops.ts";
import { productService } from "./services/products.ts";
import { productPricesService } from "./services/product_prices.ts";
import { fertiProductService } from "./services/ferti_products.ts";
import { fertiProductPricesService } from "./services/ferti_product_prices.ts";

//ELEMENTS
const welcomeMessageWindow = document.querySelector(".welcome-message-window");

export const updateFormColumn1 = document.querySelector(".upload__column1");
export const updateWindow1 = document.querySelector(".update-window1");
export const form1 = document.querySelector(".upload1");
export const btnModal1 = document.querySelector(".table_modal1");
export const updateFormColumn2 = document.querySelector(".upload__column2");
export const updateWindow2 = document.querySelector(".update-window2");
export const form2 = document.querySelector(".upload2");
export const btnModal2 = document.querySelector(".table_modal2");
//export const uploadBtn = updateWindow1.querySelector(".upload__btn");
export const updateFormColumn3 = document.querySelector(".upload__column3");
export const updateWindow3 = document.querySelector(".update-window3");
export const form3 = document.querySelector(".upload3");
export const btnModal3 = document.querySelector(".table_modal3");
export const updateFormColumn4 = document.querySelector(".upload__column4");
export const updateWindow4 = document.querySelector(".update-window4");
export const form4 = document.querySelector(".upload4");
export const btnModal4 = document.querySelector(".table_modal4");
const updateAccountWindow = document.querySelector(".update-account-window");
const btnAccountModal = document.querySelector(".account_modal");
const accountForm = document.querySelector(".upload-account");

export const deleteRowWindow = document.querySelector(".delete-row-window");
export const deleteBtn = deleteRowWindow.querySelector(".ok-delete__btn");
export const notDeleteBtn = deleteRowWindow.querySelector(".not-delete__btn");
export const deleteModalBtn = deleteRowWindow.querySelector(
  ".alert-delete_modal"
);
export const updateFormColumn5 = document.querySelector(
  ".upload__column_sector"
);
export const updateWindow5 = document.querySelector(".update-sector-window");
export const form5 = document.querySelector(".upload-sector");
export const btnModal5 = document.querySelector(".sector_modal");

//Logout elements
const btnLogout = document.querySelector(".logout__btn");
export const menuTag = document.querySelector(".menu-tag");

//Table elements
const btnModal = document.querySelector(".table_modal");

//Help elements
const helpWindow = document.querySelector(".help-window");

//Account elements
const accountWindow = document.querySelector(".account-window");

//Company Elements
const companyNav = document.querySelector(".company_nav");
export const companyTableWindow = document.querySelector(
  ".company_table_window"
);

//Product Elements
const productNav = document.querySelector(".product_nav");
export const productTableWindow = document.querySelector(
  ".product_table_window"
);

//FertiProduct Elements
const fertiProductNav = document.querySelector(".fertiProduct_nav");
export const fertiProductTableWindow = document.querySelector(
  ".fertiProduct_table_window"
);

//Crop Elements
const cropNav = document.querySelector(".crop_nav");
export const cropTableWindow = document.querySelector(".crop_table_window");

//Sector Elements
const sectorNav = document.querySelector(".sector_nav");
export const sectorTableWindow = document.querySelector(".sector_table_window");

//NewPlan Elements
const newPlanWindow = document.querySelector(".new-plan-window");

//OpenPlan Elements
const openPlanWindow = document.querySelector(".open-plan-window");

//INIT VALUES FROM STORAGE - products
export const productRowsValid = async function () {
  const result = await productService.listProducts();
  if (!result.success) {
    console.error("Failed to load products:", result.error);
    return productRowsDefault; // Fallback to default if API fails
  }

  // Transform the data to match the old structure and fetch prices for each product
  const productsWithPrices = await Promise.all(
    result.data.map(async (product) => {
      // Get prices for this product
      const pricesResult = await productPricesService.listPricesByProduct(
        product.id
      );
      const countEurokg = pricesResult.success
        ? pricesResult.data.map((price) => [
            price.companies.id, // company id
            price.price_per_kg, // price per kg
          ])
        : [];

      return {
        productId: product.id,
        product: product.product_name,
        countN: product.nitrogen_n,
        countP2O5: product.phosphorus_p2o5,
        countK2O: product.potassium_k2o,
        countCaO: product.calcium_cao,
        countMgO: product.magnesium_mgo,
        countSO3: product.sulfur_so3,
        countEurokg,
      };
    })
  );

  return productsWithPrices;
};

//INIT VALUES FROM STORAGE - fertiProducts
export const fertiProductRowsValid = async function () {
  const result = await fertiProductService.listFertiProducts();
  if (!result.success) {
    console.error("Failed to load ferti products:", result.error);
    return fertiProductRowsDefault; // Fallback to default if API fails
  }

  // Transform the data to match the old structure and fetch prices for each product
  const productsWithPrices = await Promise.all(
    result.data.map(async (product) => {
      // Get prices for this product
      const pricesResult = await fertiProductPricesService.listPricesByProduct(
        product.id
      );
      const countEurokg = pricesResult.success
        ? pricesResult.data.map((price) => [
            price.companies.id, // company id
            price.price_per_kg, // price per kg
          ])
        : [];

      return {
        productId: product.id,
        product: product.product_name,
        countN: product.nitrogen_n,
        countP2O5: product.phosphorus_p2o5,
        countK2O: product.potassium_k2o,
        countCaO: product.calcium_cao,
        countMgO: product.magnesium_mgo,
        countSO3: product.sulfur_so3,
        conductivity: product.conductivity_ms_cm,
        specificWeightKgl: product.specific_weight_kg_l,
        solubilCoeff: product.solubility_coeff,
        countEurokg,
      };
    })
  );

  return productsWithPrices;
};

//INIT VALUES FROM STORAGE - crops
export const cropRowsValid = async function () {
  const result = await cropService.listCrops();
  if (!result.success) {
    console.error("Failed to load crops:", result.error);
    return cropRowsDefault; // Fallback to default if API fails
  }

  // Transform the data to match the old structure
  return result.data;
};

//INIT VALUES FROM STORAGE - companies
export const companyRowsValid = async function () {
  const result = await companyService.listCompanies();
  if (!result.success) {
    console.error("Failed to load companies:", result.error);
    return;
  }

  // Transform the data to match the old structure
  return result.data.map((company) => ({
    companyId: company.id,
    company: company.company_name,
    address: {
      street: company.street || "",
      city: company.city || "",
      province: company.province || "",
      country: company.country || "",
    },
    tel: company.telephone || "",
  }));
};

//INIT VALUES FROM STORAGE - sector
export const sectorRowsValid = async function (sectors) {
  const result = await sectorService.listSectors();
  if (!result.success) {
    console.error("Failed to load sectors:", result.error);
    return;
  }
  // Transform the data to match the old structure
  return result.data.map((sector) => ({
    sectorId: sector.id,
    name: sector.sector_name,
    companyId: sector.company_id,
    cropId: sector.crop_id,
    length: sector.length_m,
    width: sector.width_m,
    distanceSupplyRows: sector.distance_supply_row,
    distanceSuppliers: sector.distance_suppliers_cm,
    nominalFlowRate: sector.nominal_flow_rate_lh,
    fertiFlowRate: sector.ferti_flow_rate_lh,
    pipeLength: sector.pipe_length_m,
  }));
};

//INIT VALUES FROM STORAGE - plan
export const planRowsValid = async function (plans) {
  const result = await planService.listPlans();
  if (!result.success) {
    console.error("Failed to load plans:", result.error);
    return plans;
  }

  return result.data;
};

//INIT VALUES FROM STORAGE - accounts
export const accountRowsValid = async function () {
  const result = await authService.getCurrentUserWithRole();

  return result;
};

// Initialize data containers
export let productRows = [];
export let fertiProductRows = [];
export let cropRows = [];
export let companyRows = [];
export let sectorRows = [];
export let planRows = [];
export let accountRows = {};

// Data initialization function
export const initializeData = async function () {
  try {
    productRows = await productRowsValid();
    fertiProductRows = await fertiProductRowsValid();
    cropRows = await cropRowsValid();
    companyRows = await companyRowsValid();
    sectorRows = await sectorRowsValid(sectors);
    planRows = await planRowsValid(plans);
    accountRows = await accountRowsValid();

    console.log("All data initialized successfully");
  } catch (error) {
    console.error("Error initializing data:", error);
  }
};

btnLogout.addEventListener("click", async function (e) {
  e.preventDefault();
  const result = await auth.signOut();
  if (!result.success) {
    console.error("Logout failed:", result.error);
  }
});

// Export the control functions
export const controlNewPlan = async function (currBtn) {
  console.log("newPlan");
  updateUI(currBtn);
  await controlNewPlanProject(newPlanWindow, currBtn, auth.currentAccount);
  hideMenu();
};

export const controlOpenPlan = function (currBtn) {
  console.log("openPlan");
  updateUI(currBtn);
  controlOpenPlanProject(openPlanWindow, currBtn, auth.currentAccount);
  hideMenu();
};

export const controlNewPlanTest = async function (currBtn) {
  await planController.init(currBtn);
};

export const controlCompany = async function (currBtn, currAcc) {
  await companyController.init(currBtn, currAcc);
};

export const controlProduct = async function (currBtn, currAcc) {
  await productController.init(currBtn, currAcc);
};

export const controlFertiProduct = async function (currBtn, currAcc) {
  await fertiProductController.init(currBtn, currAcc);
};

export const controlCrop = async function (currBtn, currAcc) {
  await cropController.init(currBtn, currAcc);
};

export const controlSector = async function (currBtn, currAcc) {
  await sectorController.init(currBtn, currAcc);
};

const updateUI = function (currBtn) {
  initMenu(menuTag);
  currBtn.classList.add("menu__btn--active");
  clearAll();
};

const clearAll = function () {
  clear(helpWindow);
  clear(companyNav);
  clear(companyTableWindow);
  clear(productNav);
  clear(productTableWindow);
  clear(fertiProductNav);
  clear(fertiProductTableWindow);
  clear(cropNav);
  clear(cropTableWindow);
  clear(sectorNav);
  clear(sectorTableWindow);
  clear(accountWindow);
  clear(welcomeMessageWindow);
  clear(newPlanWindow);
  clear(openPlanWindow);
};
